var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { slot: "tool" }, slot: "tool" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _vm._v("    \n      "),
            _vm.canEdit() &&
            _vm.userCanDoAction &&
            _vm.affaire.affaire.etape ===
              _vm.CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value &&
            _vm.affaire.affaire.status !==
              _vm.CONST.AFFAIRE.STATUS.ARCHIVED.value
              ? _c(
                  "div",
                  [
                    !_vm.modeEdit
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "can",
                                rawName: "v-can:avenant",
                                value: "creer",
                                expression: "'creer'",
                                arg: "avenant"
                              }
                            ],
                            attrs: {
                              type: "success",
                              size: "mini",
                              icon: "el-icon-plus"
                            },
                            on: { click: _vm.handleNewAvenant }
                          },
                          [_vm._v("Nouvel avenant")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.modeEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              size: "mini",
                              icon: "el-icon-close"
                            },
                            on: { click: _vm.handleCancelAvenant }
                          },
                          [_vm._v("Annuler")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.modeEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-check"
                            },
                            on: { click: _vm.handleSaveAvenant }
                          },
                          [_vm._v("Enregistrer")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "SyncScrollBars",
        [
          _vm._l(_vm.affaire.lots, function(lot, index) {
            return _c(
              "el-row",
              { key: lot.id + "_" + _vm.refresh },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("h1", { staticStyle: { "margin-top": "10px" } }, [
                          _vm._v(
                            "Lot " +
                              _vm._s(index + 1) +
                              " " +
                              _vm._s(lot.libelle)
                          )
                        ]),
                        _vm._v(" "),
                        _c("LotDetail", {
                          key: "LotDetail_" + _vm.refresh,
                          attrs: { idLot: lot.id }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "el-row",
            { key: "e2_" + _vm.refresh, staticStyle: { margin: "20px 0" } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [_c("AffaireTotaux", { key: "Totaux_" + _vm.refresh })],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }